// extracted by mini-css-extract-plugin
export default {"LoadingSpinner":"LoadingSpinner_LoadingSpinner","LoadingSpinner8":"LoadingSpinner_LoadingSpinner8"};